// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { advanceRowsStyles } from "@west/Overrides/Widgets/Basic/Rows";
import { constants } from "@west/XDL/constants";
import { layoutContainer, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

advanceRowsStyles.container = {
    css: css`
        max-width: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        ${({ gap }: any) =>
            gap &&
            css`
                gap: ${gap}px;
            `};

        ${({ removeFooterOffset }: any) =>
            removeFooterOffset &&
            css`
                margin-bottom: -${constants.footer.offsetTop}px;
            `}

        @media print {
            display: block;
        }
    `,
};

advanceRowsStyles.item = {
    css: css`
        width: 100%;
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

        ${({ backgroundColor }: any) =>
            backgroundColor &&
            css`
                background-color: ${backgroundColor};
            `}

        ${({ contentVerticalPadding }: any) =>
            contentVerticalPadding &&
            css`
                padding-top: ${contentVerticalPadding}px;
                padding-bottom: ${contentVerticalPadding}px;
            `}
        ${({ containerMobileFullWidth }: any) =>
            containerMobileFullWidth &&
            css`
                &&&.mobile-full-width {
                    ${xScreen("lte", "xs")} {
                        max-width: 100%;
                        margin-right: 0;
                        margin-left: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
            `}

        // Check containerFullWidth by className
        ${layoutContainer}

        @media print {
            display: block;
            ${({ gap }: any) =>
                gap &&
                css`
                    margin: ${gap / 2}px 0;
                `}
        }
    `,
};
